<!-- 
<div class="status-change-reports-container col-md-12 no-padding">
    <div id="statusChangeReport">
        <div class="row no-margin">
            <div class="col-md-12 no-padding">
                <div id="icons-container" class="row float-right paddingtop-10">
                    <div class="col-md-12 no-padding">
                        <div class="col-md-3 right-padding-0 align-print-icon">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile('print')" (click)="exportFile('print')"
                                class="iconButtons no-margin" [disabled]="isAllStatusChangeReportLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="printIconUrl" alt="{{'customer-service.Print' |translate |translateKey }}"
                                        title="{{'customer-service.Print' |translate |translateKey }}" />
                                </span>
                            </button>
                        </div>        
                        <div class="col-md-3 right-padding-0">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile('csv')" (click)="exportFile('csv')"
                                class="iconButtons no-margin" [disabled]="isAllStatusChangeReportLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="excelIconUrl"
                                        alt="{{'reports.Export CSV' |translate |translateKey}}"
                                        title="{{'reports.Export CSV' |translate |translateKey}}"/>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 no-padding mt-10 mb-10">
            <div class="table-responsive">
                <table class="table-sm table-hover table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th class="cursor-pointer">{{'reports.ID #' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Last Name' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'reports.First Name' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Member Type' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Previous Status' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'reports.New Status' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'reports.User' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Notes' |translate |translateKey  }}&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody
                        *ngIf="!isLoading && statusChangeReport && statusChangeReport.length > 0">
                        <tr
                            *ngFor="let report of statusChangeReport | paginate: {  id: 'status-changes-reports-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
                           
                            <td>{{report.distributorId}}</td>
                            <td>{{report.lastName}}</td>
                            <td>{{report.firstName}}</td>
                            <td>{{report.memberType}}</td>
                            <td>{{report.previousStatus}}</td>
                            <td>{{report.newStatus}}</td>
                            <td>{{report.userFirstName + ' ' + report.userLastName}}</td>
                            <td>{{report.description}}</td>
                        </tr>
                    </tbody>
                    <tbody
                        *ngIf="(!isLoading && (statusChangeReport && statusChangeReport.length === 0)) || (isResponseError && !isLoading)">
                        <tr>
                            <td colspan="29"  class="text-center ">{{'customer-service.No record(s) found' |translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="isLoading">
                        <tr>
                            <td colspan="29" class="text-center">{{'customer-service.Loading Results, Please wait.'|translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-5 paddingbot-20"
                *ngIf="statusChangeReport && statusChangeReport.length > 0">
                <span>{{pageCount}} {{'customer-service.record(s) found' |translate |translateKey}}</span>
                <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right">
                </pagination-controls>
            </div>
        </div>
        <div class="col-md-12 padding-lr-0 paddingbot-20">
            <div class="col-md-4 padding-lr-0">
                <select class="form-control per-page-width" id="currentPageSize" [(ngModel)]="pageSize"
                    [disabled]="!(statusChangeReport && statusChangeReport.length > 0)"
                    (change)="pageSizeChange($event.target.value)" name="currentPageSize" #currentPageSize="ngModel">
                    <option *ngFor="let pageSize of pageSizes" [value]="pageSize">{{pageSize}}</option>
                </select>
            </div>
        </div>
    </div>
</div> -->
<div class="row w-100 no-margin message paddingtop-20"
    *ngIf="(!isLoading && (statusChangeReport && statusChangeReport.length === 0)) || (isResponseError && !isLoading)">
    <div class="w-100 messageContent text-center">
        <strong class="">{{'customer-service.No record(s) found' |translate | translateKey}}.</strong>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/reports/account-status-change-report.component.html